// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"dfd2b62f","713":"259d7a0f"}[chunkId] + ".chunk.css";
};